import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=f81c52da"
import script from "./parameter.vue?vue&type=script&lang=ts"
export * from "./parameter.vue?vue&type=script&lang=ts"
import style0 from "./parameter.vue?vue&type=style&index=0&id=f81c52da&prod&lang=stylus"
import style1 from "./parameter.vue?vue&type=style&index=1&id=f81c52da&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports